import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardOPDLabSummaryUX = (props: any) => {
    return(
      <div
        id="CardOPDLabSummaryUX-div-0"
        style={{width: "100%", padding: "15px 10px"}}>
        <div
          id="CardOPDLabSummaryUX-div-1">
          
          <label
            id="CardOPDLabSummaryUX-label-2"
            style={{fontSize: "1.5rem", fontWeight: "bold"}}>
            {props.title || ""}
          </label>
        </div>
        <div
          className="ui form"
          id="CardOPDLabSummaryUX-div-3"
          style={{paddingTop: "2rem"}}>
          
          <div
            className="inline fields"
            id="CardOPDLabSummaryUX-div-26"
            style={{display: props.config?.hideClinicalSummary ? "none" : ""}}>
            
            <FormField
              id="CardOPDLabSummaryUX-FormField-27"
              inline={true}
              width={13}>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-28"
              inline={true}
              width={3}>
              <Button
                color="teal"
                disabled={props.config?.disabledClinicalSummary || false}
                fluid={true}
                id="CardOPDLabSummaryUX-Button-29"
                onClick={props.onClinicalSummary}>
                {props.languageUX === "en" ? "Clinical summary" : "Clinical summary"}
              </Button>
            </FormField>
          </div>
          <FormGroup
            id="CardOPDLabSummaryUX-FormGroup-5"
            inline={true}>
            <FormField
              id="CardOPDLabSummaryUX-FormField-9"
              inline={true}>
              <label
                id="CardOPDLabSummaryUX-label-17"
                style={{fontWeight: "bold", width: "110px"}}>
                {props.languageUX === "en" ? "Date of service" : "วันที่รับบริการ"}
              </label>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-10"
              inline={true}
              width={16}>
              <Dropdown
                clearable={props.config?.showFromDate || false}
                id="CardOPDLabSummaryUX-Dropdown-18"
                name="encounterId"
                onChange={props.onChangeValue}
                options={props.encounterOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.encounterId || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <div
            className="inline fields"
            id="CardOPDLabSummaryUX-div-30"
            style={{display: props.config?.showFromDate ? "" : "none"}}>
            
            <FormField
              id="CardOPDLabSummaryUX-FormField-31"
              inline={true}>
              <label
                id="CardOPDLabSummaryUX-label-33"
                style={{fontWeight: "bold",width: "110px"}}>
                {props.languageUX === "en" ? "From" : "จาก"}
              </label>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-32"
              inline={true}
              width={16}>
              <Dropdown
                clearable={true}
                id="CardOPDLabSummaryUX-Dropdown-34"
                name="fromEncounterId"
                onChange={props.onChangeValue}
                options={props.encounterOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.fromEncounterId || ""}>
              </Dropdown>
            </FormField>
          </div>
          <FormGroup
            id="CardOPDLabSummaryUX-FormGroup-6"
            inline={true}>
            <FormField
              id="CardOPDLabSummaryUX-FormField-11"
              inline={true}>
              <label
                id="CardOPDLabSummaryUX-label-19"
                style={{fontWeight: "bold",width: "110px"}}>
                {props.languageUX === "en" ? "Lab Division" : "Lab Division"}
              </label>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-12"
              inline={true}
              width={6}>
              <Dropdown
                id="CardOPDLabSummaryUX-Dropdown-21"
                multiple={props.multipleLabDivision|| false}
                name="divisionId"
                onChange={props.onChangeValue}
                options={props.labDivisionOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.divisionId}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-13"
              inline={true}
              width={2}>
              <label
                id="CardOPDLabSummaryUX-label-20"
                style={{width: "100%", textAlign: "center"}}>
                {props.languageUX === "en" ? "Lab Name" : "Lab Name"}
              </label>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-14"
              inline={true}
              width={6}>
              <Dropdown
                id="CardOPDLabSummaryUX-Dropdown-22"
                multiple={props.multipleLabName || false}
                name="labName"
                onChange={props.onChangeValue}
                options={props.labNameOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.labName}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardOPDLabSummaryUX-FormField-15"
              inline={true}
              width={2}>
              <div
                id="CardOPDLabSummaryUX-div-36"
                style={{width: "100%"}}>
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardOPDLabSummaryUX-div-24">
          
          <Table
            data={props.labResultList || []}
            getTdProps={props.getTdProps}
            getTheadThProps={props.getTheadThProps}
            headers={`Code,Lab Name,Reference value, Unit,Result ${props.encounterDate ? `[${props.encounterDate}]`:""},Previous Result`}
            id="CardOPDLabSummaryUX-Table-25"
            keys="code, lab_name, ref_value,unit,result, prev_result"
            showPagination={false}
            style={{height: "600px", display: props.cumulativeLabTable ? "none" : ""}}>
          </Table>
          <div
            id="CardOPDLabSummaryUX-div-35">
            {props.cumulativeLabTable}
          </div>
        </div>
      </div>
    )
}


export default CardOPDLabSummaryUX

export const screenPropsDefault = {"language":"TH","price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"15px 10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.5rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รับบริการ",
          "valueEN": "Date of service"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", width: \"110px\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Dropdown",
      "parent": 10,
      "props": {
        "clearable": {
          "type": "code",
          "value": "props.config?.showFromDate || false"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-Dropdown-18"
        },
        "name": {
          "type": "value",
          "value": "encounterId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.encounterOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.encounterId || \"\""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Division",
          "valueEN": "Lab Division"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",width: \"110px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Name",
          "valueEN": "Lab Name"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-label-20"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", textAlign: \"center\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Dropdown",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-Dropdown-21"
        },
        "multiple": {
          "type": "code",
          "value": "props.multipleLabDivision|| false"
        },
        "name": {
          "type": "value",
          "value": "divisionId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.labDivisionOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.divisionId"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-Dropdown-22"
        },
        "multiple": {
          "type": "code",
          "value": "props.multipleLabName || false"
        },
        "name": {
          "type": "value",
          "value": "labName"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.labNameOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.labName"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 25,
      "name": "Table",
      "parent": 24,
      "props": {
        "data": {
          "type": "code",
          "value": "props.labResultList || []"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTheadThProps": {
          "type": "code",
          "value": "props.getTheadThProps"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "code",
          "value": "`Code,Lab Name,Reference value, Unit,Result ${props.encounterDate ? `[${props.encounterDate}]`:\"\"},Previous Result`"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-Table-25"
        },
        "keys": {
          "type": "value",
          "value": "code, lab_name, ref_value,unit,result, prev_result"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"600px\", display: props.cumulativeLabTable ? \"none\" : \"\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "inline fields"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideClinicalSummary ? \"none\" : \"\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Button",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "Clinical summary",
          "valueEN": "Clinical summary"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.disabledClinicalSummary || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-Button-29"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClinicalSummary"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "inline fields"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.showFromDate ? \"\" : \"none\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "จาก",
          "valueEN": "From"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",width: \"110px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 32,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-Dropdown-34"
        },
        "name": {
          "type": "value",
          "value": "fromEncounterId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.encounterOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.fromEncounterId || \"\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cumulativeLabTable"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardOPDLabSummaryUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 36,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardOPDLabSummaryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH",
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
